import { setInteractiveState } from "src/redux/actions/flights/FlightTimeline.Actions";
import { InteractiveState } from "src/redux/reducers/FlightTimelineReducer";
import { DialogModalStyles, EventModalTypes } from "../DialogModalWrapper";
import { useDispatch, useSelector } from "react-redux";
import { useTheme, DialogActions, DialogContent } from "@mui/material";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import { IFlight, IGroundEvent } from "@vmosolutions/oc-interfaces";
import { useCallback } from "react";
import { ModalTitle, ModalMessage, ModalButton } from "../DialogModalComponents";

interface IReassignFlightModalProps {
  windowId: string;
  isOpen: boolean;
  handleClose: (value: boolean) => void;
  setActiveEventModal: (EventModalTypes: EventModalTypes) => void;
  isGroundEvent: boolean;
}

export const ReassignFlightModal = (props: IReassignFlightModalProps): JSX.Element => {
  const { windowId, isOpen, handleClose, setActiveEventModal, isGroundEvent } = props;
  const dispatch = useDispatch();
  const theme = useTheme();
  const selectedEvents: (IFlight | IGroundEvent)[] = useSelector(
    (state: IRootState) => state.timelineFlights.selectedEvents
  );
  const currentNode = useSelector((state: IRootState) => state.windowManager.currentNode);

  const handleCancel = useCallback((): void => {
    handleClose(false);
    setActiveEventModal(EventModalTypes.None);
  }, [handleClose, setActiveEventModal]);

  const handleConfirm = useCallback((): void => {
    handleClose(false);
    setActiveEventModal(EventModalTypes.None);
    dispatch(setInteractiveState(InteractiveState.Reassign, windowId));
  }, [dispatch, handleClose, setActiveEventModal, windowId]);

  if (isOpen) {
    return (
      <DialogContent sx={DialogModalStyles(theme)}>
        <div className="modal_content">
          <ModalTitle title={`Re-assign ${!isGroundEvent ? "Flight" : "Ground Event"}`}></ModalTitle>
          <ModalMessage
            message={`Are you sure you would like to re-assign this ${!isGroundEvent ? "flight" : "ground event"}?`}
          ></ModalMessage>
          <DialogActions>
            <ModalButton label={"Cancel"} handler={handleCancel}></ModalButton>
            <ModalButton label={"Confirm"} handler={handleConfirm}></ModalButton>
          </DialogActions>
        </div>
      </DialogContent>
    );
  } else {
    return <></>;
  }
};
